import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import type { BoundaryGroupDemographic } from '~/store/boundaryGroups/boundaryGroups.repository';
import {
  type DemographicsDataProvider, DemographicsDataProviders,
} from '~/store/demographics/demographics.types';
import { type AppState } from '../../app.store';

export const demographicsListPremiumIsLoadingSelector = (state: AppState) => state.demographics.listPremium.isLoading;
export const useDemographicsListPremiumIsLoadingSelector = () => useSelector(demographicsListPremiumIsLoadingSelector);

export const demographicsListPremiumIsLoadedSelector = (state: AppState) => state.demographics.listPremium.isDataFetched;
export const useDemographicsListPremiumIsLoadedSelector = () => useSelector(demographicsListPremiumIsLoadedSelector);

export const demographicsListPremiumAllSelector = createStateSelector(
  [(state: AppState) => state.demographics.listPremium],
  (premiumStatsState): ReadonlyArray<BoundaryGroupDemographic> =>
    Object.values(DemographicsDataProviders)
      .map(provider => premiumStatsState[provider]?.flatMap(region => region.demographics) ?? [])
      .flat()
);

export const demographicsListPremiumRegionsSelector = (state: AppState) => state.demographics.listPremium;
export const useDemographicsListPremiumRegionSelector = (provider: DemographicsDataProvider) =>
  useSelector(demographicsListPremiumRegionsSelector)[provider];
